/* Fil d'Ariane des pages modèle (snippets/breadcrumbs.liquid, data-lb-fil).
   Chaque page collection s'enregistre en sessionStorage (clé = location.pathname, qui contient déjà
   le préfixe de langue) : { t: titre, r: racine de langue, m: page modèle, mid: lien du milieu retenu }.
   Sur une page modèle, le lien du milieu (rendu serveur = page marque) devient la page précédente
   exacte quand le referrer vivant est une page du site enregistrée dans la même langue ; si cette page
   précédente est elle-même une page modèle, on reprend son lien du milieu. Sinon rien ne change. */
(function () {
  'use strict';
  if (window.lbFilDone) return;
  window.lbFilDone = true;

  var KEY = 'lbFil';
  var MAX = 30;

  function sameOrigin(u) {
    try {
      var p = new URL(u, location.href);
      return p.origin === location.origin ? p : null;
    } catch (e) { return null; }
  }

  function run() {
    var nav = document.querySelector('nav[data-lb-fil]');
    if (!nav) return;
    var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    var store = {};
    try { store = JSON.parse(window.sessionStorage.getItem(KEY) || '{}') || {}; } catch (e) { store = {}; }
    if (typeof store !== 'object' || Array.isArray(store)) store = {};

    var mid = nav.getAttribute('data-lb-fil-m') === '1' ? nav.querySelector('a[data-lb-fil-mid]') : null;
    if (mid) {
      var ref = document.referrer ? sameOrigin(document.referrer) : null;
      var e = ref ? store[ref.pathname] : null;
      var u = null, t = null;
      if (e && typeof e === 'object' && e.r === root) {
        if (e.m) {
          var m = e.mid && sameOrigin(e.mid.u);
          if (m && e.mid.t) { u = m.href; t = String(e.mid.t); }
        } else if (e.t) {
          u = ref.href; t = String(e.t);
        }
      }
      if (u && t) {
        mid.setAttribute('href', u);
        mid.textContent = t;
      }
    }

    var entry = { t: nav.getAttribute('data-lb-fil') || '', r: root, s: Date.now() };
    if (mid) { entry.m = 1; entry.mid = { u: mid.href, t: mid.textContent }; }
    delete store[location.pathname];
    store[location.pathname] = entry;
    var keys = Object.keys(store);
    if (keys.length > MAX) {
      keys.sort(function (a, b) { return ((store[a] && store[a].s) || 0) - ((store[b] && store[b].s) || 0); });
      keys.slice(0, keys.length - MAX).forEach(function (k) { delete store[k]; });
    }
    try { window.sessionStorage.setItem(KEY, JSON.stringify(store)); } catch (e2) { /* stockage indisponible : rendu serveur conservé */ }
  }

  try { run(); } catch (e) { /* jamais bloquant : le lien serveur (page marque) reste */ }
})();
